// Shared client-side constants. Extracted to keep magic numbers out of
// component bodies and to centralise any tuning of motion / data fetching.

// Stagger delay (ms) between sibling entrance animations.
export const STAGGER_MS = 70;

// React Query: keep cached data fresh for one minute before refetch.
export const STALE_TIME_MS = 60_000;
